import {
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  RESET_CHANGE_PASSWORD_STATUS,
  RESET_CHANGE_PASSWORD_ERROR,
} from "./actionTypes";

const initialState = {
  status: "idle", // or: 'loading', 'success', 'failed',
  error: "",
};

const ChangePassword = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_PASSWORD:
      return {
        ...state,
        status: "loading",
      };

    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        status: "success",
      };

    case CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        status: "failed",
        error: action.payload,
      };

    case RESET_CHANGE_PASSWORD_STATUS:
      return {
        ...state,
        status: "idle",
      };

    case RESET_CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        error: "",
      };

    default:
      return state;
  }
};

export default ChangePassword;
